var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isTop)?_c('span',{staticClass:"tag is-warning is-light is-small top-firm-badge",attrs:{"data-test":"top-firm-badge"}},[_vm._v("פירמה מובילה")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }